import { render } from "./DataPreparationAvroHandlingDialog.vue?vue&type=template&id=3f59df4e&ts=true"
import script from "./DataPreparationAvroHandlingDialog.vue?vue&type=script&lang=ts"
export * from "./DataPreparationAvroHandlingDialog.vue?vue&type=script&lang=ts"

import "./DataPreparationAvroHandlingDialog.vue?vue&type=style&index=0&id=3f59df4e&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__